import ObjectBuilderClient from './components/ObjectBuilderClient';
export default ObjectBuilderClient;